<template>
  <main class="l-main p-config-project">
    <TitleMain icon="configSite">
      <span class="title">サイト設定</span>
    </TitleMain>
    <div class="l-container">
      <div class="l-toolBlock">
        <ButtonToProjects />
        <Breadcrumb />
      </div>
      <section class="c-section">
        <div class="l-block">
          <div class="l-block__header">
            <TitleSub icon="project" level="h2">
              <span class="title">サイト基本情報</span>
            </TitleSub>
          </div>
          <div class="l-block__content">
            <EditProject :project="project" :isLoading="isLoading" />
          </div>
          <div v-if="isVisibleGaVersion" class="l-block__content">
            <EditGaVersion :project="project" />
          </div>
        </div>
      </section>
      <section class="c-section" id="siteImportantKeyword">
        <div class="l-block">
          <div class="l-block__header">
            <TitleSub icon="sitekeywordanalysis" level="h2">
              <span class="title">検索順位キーワード一覧</span>
            </TitleSub>
          </div>
          <div class="l-block__content">
            <EditSeedKeyword :project="project" />
          </div>
        </div>
      </section>
      <section class="c-section">
        <div class="l-block">
          <div class="l-block__header">
            <TitleSub level="h2">
              <Icon2 variant="pen-circle" :size="36" color="main" />
              <span class="title">指名キーワード一覧</span>
            </TitleSub>
          </div>
          <div class="l-block__content">
            <EditNominatedKeyword :project="project" />
          </div>
        </div>
      </section>
    </div>
  </main>
</template>
<script>
import ButtonToProjects from '@/components/ButtonToProjects';
import Breadcrumb from '@/components/Breadcrumb';
import Icon2 from '@/components/Icon2';
import TitleMain from '@/components/TitleMain';
import TitleSub from '@/components/TitleSub';
import EditGaVersion from '@/components/edit/EditGaVersion';
import EditProject from '@/components/edit/EditProject';
import EditSeedKeyword from '@/components/edit/EditSeedKeyword';
import EditNominatedKeyword from '@/components/edit/EditNominatedKeyword';

export default {
  props: ['keyword', 'keywordId', 'project', 'hasProject'],
  components: {
    ButtonToProjects,
    Breadcrumb,
    Icon2,
    TitleMain,
    TitleSub,
    EditGaVersion,
    EditProject,
    EditSeedKeyword,
    EditNominatedKeyword
  },
  data() {
    return {
      isLoading: true
    };
  },
  computed: {
    isVisibleGaVersion() {
      return (
        !this.isLoading && this.project.ga4AccountId && this.project.gaAccountId
      );
    }
  },
  created() {
    this.$store
      .dispatch('user/getProject', { projectId: this.project.id })
      .finally(() => {
        this.isLoading = false;
      });
  },
  mounted() {
    const hash = this.$route.hash;
    if (hash && hash.match(/^#.+$/)) {
      this.$scrollTo(hash);
    }
  }
};
</script>
